module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.4312f1f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Regular/Roboto-Regular.ttf
// module id = P7hP
// module chunks = 24